import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Modal, Button } from 'antd';
import { TIME_SELECT_MODAL_TYPE } from 'src/constants/normal';

import i18n from 'src/i18n';

import styles from './styles.module.scss';


@observer
class TimeSelectModal extends React.Component {
  constructor() {
    super();

  }

  render() {
    const { viewModel } = this.props;
    return (
      <Modal
        open={viewModel.isOpen}
        centered
        footer={null}
        closeIcon={null}
        width={500}
        onCancel={viewModel.onClose}
        styles={{ content: { padding: 0 } }}
      >
        <div className={styles.container}>
          <div className={styles.title}>
            {
              viewModel.type === TIME_SELECT_MODAL_TYPE.ReAnalysis
                ? i18n.t('edm_list_table_action_re-analysis')
                : i18n.t('edm_list_table_action_download_title')
            }
          </div>
          <div className={styles.content}>
            <div className={styles.contentText}>
              <span>
                {
                  viewModel.type === TIME_SELECT_MODAL_TYPE.ReAnalysis
                    ? i18n.t('result_page_table_action_reanalysis_modal_note')
                    : i18n.t('result_page_table_action_download_modal_note')
                }
              </span>
              <span>
                {viewModel.timeText}
              </span>
            </div>
          </div>
          <div className={styles.footer}>
            <Button
              className={styles.confirmBtn}
              onClick={viewModel.onConfirm}
            >
              {i18n.t('common_confirm')}
            </Button>
            <Button
              className={styles.cancelBtn}
              onClick={viewModel.onClose}
            >
              {i18n.t('common_cancel')}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

TimeSelectModal.propTypes = {
  viewModel: PropTypes.object.isRequired
};

TimeSelectModal.defaultProps = {
  // viewModel: {}
};

export default TimeSelectModal;
